<template>
  <div class="row">
    <div v-if="(back_button) && (content > 1)" class="col-6 mt-4">
      <button class="btn btn-clear" @click.prevent="stepBack();">
        <i class="fa fa-angle-double-left" aria-hidden="true"></i> &nbsp; {{ backButtonLabel }}
      </button>
    </div>
    <div class="mt-4 text-right" :class="[(back_button) && (content > 1) ? 'col-6' : 'col-6 offset-6']">
      <button @click.prevent="nextStep()" type="submit" class="btn btn-primary-click" :class="{disabled : disabled}">
        {{ nextStepButtonLabel }} &nbsp; <i class="fa fa-angle-double-right" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</template>
<script>
const NEXT_TEXT = 'weiter';

import General from '@/mixins/general';

export default {
  mixins: [General],
  props: {
    value: {
      type: Number,
      required: true
    },
    back_button: {
      type: Boolean,
      default: true
    },
    submitButton: {
      type: String,
    }
  },
  data() {
    return {
      nextStepButtonLabel: 'weiter',
      backButtonLabel: 'zurück',
      content: this.value,
      disabled: false
    }
  },
  mounted() {
    this.submitButton ? this.nextStepButtonLabel = this.submitButton : this.nextStepButtonLabel = NEXT_TEXT;
  },
  methods: {
    nextStep() {
      if (this.validateForm()) {
        this.content += 1;
        this.sendGaEvent(this.content);
        this.$emit('input', this.content)
      }
    },
    stepBack() {
      if (this.content > 1) {
        this.content -= 1;
        this.sendGaEvent(this.content);
        this.$emit('input', this.content)
      }
    }
  },
  watch: {
    $global: function (newV) {
      this.disabled = newV.errorCount > 0;
    }
  }
}
</script>
